module.exports = __webpack_public_path__ + "static/media/profileCircle.b4767068.svg";